<template>
  <div v-if="job">
    <div class="d-flex align-items-center">
      <b> Opportunity </b>
      <i
        class="fas fa-edit ml-1 link"
        data-cy="edit-job-opportunity"
        @click="toggleModal"
      />
    </div>
    <div>Owner: {{ job.owner ? job.owner.full_name : "--" }}</div>
    <div>
      Opportunity:
      <MembershipOpportunityLink
        :update-url="job.links.lock_membership_opportunity"
        :membership-opportunity="job.membership_opportunity"
        @save-success="$emit('save-success')"
      />
    </div>
    <div>Status: {{ capitalize(job.opportunity_status) || "--" }}</div>
    <div>
      <span>Lead: {{ job.lead_type || "--" }}</span>
      <span v-if="job.lead_source">
        <em>({{ job.lead_source }})</em>
      </span>
    </div>
    <div v-if="telephonyEnabled">
      <div>Booking Call: {{ bookingCallId }}</div>
      <div v-if="job.booking_call">
        <div>{{ job.booking_call.caller.name }}</div>
        <div>
          {{ job.booking_call.caller.phone_number }}
          <span
            v-if="job.booking_call.lead && job.booking_call.lead.tracking_name"
          >
            <em>({{ job.booking_call.lead.tracking_name }})</em>
          </span>
        </div>
      </div>
    </div>

    <JobOpportunityModal
      v-if="opportunityModal"
      :job-id="job.id"
      :technician="job.owner"
      :opportunity-status="job.opportunity_status"
      :lead-type="job.lead_type"
      :lead-source="job.lead_source"
      :booking-call-id="getProperty(job.booking_call, 'id')"
      @save-success="$emit('save-success')"
      @hide-modal="toggleModal"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getProperty } from "@/lib/helpers.js";

import JobOpportunityModal from "./JobOpportunityModal.vue";
import MembershipOpportunityLink from "./MembershipOpportunityLink.vue";

export default {
  components: {
    JobOpportunityModal,
    MembershipOpportunityLink
  },
  props: {
    job: {
      type: Object,
      default: null
    }
  },
  emits: ["save-success"],
  data() {
    return {
      opportunityModal: false
    };
  },
  computed: {
    ...mapState({
      telephonyEnabled() {
        return this.callRailEnabled || this.ringCentralEnabled;
      },
      callRailEnabled({ tenant }) {
        return getProperty(tenant, "call_rail_enabled");
      },
      ringCentralEnabled({ tenant }) {
        return getProperty(tenant, "ring_central_enabled");
      }
    }),
    bookingCallId() {
      const { booking_call } = this.job;
      if (!booking_call) {
        return "--";
      }
      return `#${booking_call.id}`;
    }
  },
  methods: {
    getProperty,
    toggleModal() {
      this.opportunityModal = !this.opportunityModal;
    }
  }
};
</script>

<style lang="scss" scoped></style>
